import { InlineNotification } from "@carbon/react";
import { useTranslation } from "react-i18next";

type InverseBidNoticeProps = {
  /** The order's minimum decrement, in percent. */
  decrement?: number;
  /** The highest next bid allowed, already formatted. Omitted when it differs per line (joint). */
  maxPrice?: string;
};

/**
 * SCRUM-6: how a seller updates a bid while an inverse auction is open — each
 * new bid must undercut the current one by the order's minimum decrement, and
 * the lowest bid wins.
 */
const InverseBidNotice = ({ decrement, maxPrice }: InverseBidNoticeProps) => {
  const { t } = useTranslation();

  const rule = t("tenders.inverse.updateInfo", { decrement: decrement ?? 0 });
  const limit = maxPrice
    ? ` ${t("tenders.inverse.updateInfoMax", { maxPrice })}`
    : "";

  return (
    <InlineNotification
      kind="info"
      lowContrast
      hideCloseButton
      title={t("tenders.inverse.updateInfoTitle")}
      subtitle={`${rule}${limit}`}
      className="seller-offer__inverse-notice"
    />
  );
};

export default InverseBidNotice;
